<script>
  import solicitacaoBolsaServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import Radio from '~componentes/Radio.vue';
  import ModalLiberarCancelar from '~componentes/ModalLiberarCancelar.vue';
  import BotaoReenviarEmail from '~componentes/BotaoReenviarEmail.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
import DatePicker from 'vue2-datepicker';
import ModalProtocolos from '~componentes/ModalProtocolos.vue';

  export default {
    components: { Paginacao, Radio, ModalLiberarCancelar, BotaoReenviarEmail, ModalProtocolos, ModalArquivosSolicitacao, DatePicker, ModalMensagem },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        solicitacoes: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        modalLiberarCancelar: false,
        modalArquivos: false,
        modalProtocolos: false,
        solicitacaoSelecionada: null,
        salvandoLiberacao: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
      }
    },
    methods: {
      camposFiltros() {
        return {
          tipo: 1,
          idProjeto: 0,
          mostrarSolicitacoes: '0',
          periodo: '',
          codigo: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return solicitacaoBolsaServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.solicitacoes = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolBolsa")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      mostrarModalLiberarCancelar(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalLiberarCancelar = true;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      mostrarModalProtocolos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalProtocolos = true;
      },
      liberar() {
        this.salvandoLiberacao = true;

        solicitacaoBolsaServico
          .liberar(this.solicitacaoSelecionada.idSolicitacaoBolsa)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.liberado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoBolsa} liberada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      cancelar() {
        this.salvandoLiberacao = true;

        solicitacaoBolsaServico
          .cancelar(this.solicitacaoSelecionada.idSolicitacaoBolsa)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.cancelado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoBolsa} cancelada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      liberadoOuCancelado(solicitacao) {
        return !!solicitacao.liberacaoCoordenador || !!solicitacao.statusSolicitacao;
      },
      status(solicitacao) {
        if (solicitacao.liberacaoCoordenador && solicitacao.statusSolicitacao === 0) {
          return 'Liberada pelo coordenador';
        } else if (solicitacao.statusSolicitacao === 1) {
          return 'Liberada pela instituição';
        } else if (solicitacao.statusSolicitacao === 2) {
          return 'Cancelada pela instituição';
        } else if (solicitacao.statusSolicitacao === 3 || solicitacao.statusSolicitacao === 4 || solicitacao.statusSolicitacao === 5) {
          return 'Cancelada pelo coordenador';
        } else {
          return 'Aguardando liberação';
        }
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
    modalProtocolosFechado() {
        this.animated = false;
        this.modalProtocolos = false;
        this.solicitacaoSelecionada = null;
    },
      reemviarEmail(id) {
        return solicitacaoBolsaServico.reenviarEmail(id);
      },
      erroReemviarEmail(erro, id) {
        toastr.error(`Erro ao reenviar o e-mail da solicitação nº ${id}`);
      },
      enviadoReemviarEmail(id) {
        toastr.success(`E-mail da solicitação nº ${id} reenviado com sucesso.`);
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
      tipoBolsa(tipo) {
        if (tipo === 1) {
          return 'Bolsa';
        } else if (tipo === 2) {
          return 'RPA';
        } else if (tipo === 3) {
          return 'Estágio';
        } else if (tipo === 4) {
          return 'Termo aditivo';
        } else if (tipo === 5) {
          return 'Adicional variável';
        } else {
          return '';
        }
      },
    },
    created() {
      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de ' +  this.configuracao.nomeModuloSolContratos + ' - Lista';
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-bolsa.nova';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });
    },
    computed: {
      solBolsaMsgConfirmacao() {
        if (!this.solicitacaoSelecionada)
          return this.configuracao.solBolsaMsgConfirmacao;

        if (this.solicitacaoSelecionada.tipoBolsa == 5)
          return this.configuracao.solBolsaMsgAdicionalVariavel;

        if (this.solicitacaoSelecionada.funcionarioPublico == 0)
            return "<div style='font-size: 18px;'>" +
                   "     <span style='text-decoration: underline;'><strong>INFORMAÇÃO RELEVANTE</strong></span><br /><br />" +
                   "     Anualmente, como parte dos" +
                   "     procedimentos de fiscalização, a Fundação deve apresentar ao Tribunal de Contas" +
                   "     do Estado de São Paulo – TCE/SP, uma relação com todos os pagamentos realizados" +
                   "     a beneficiários pessoas físicas, nas modalidades: autônomo, adicional de" +
                   "     inovação e bolsistas. O objetivo do órgão é realizar o cruzamento dessas" +
                   "     informações com a base de dados do governo. Ao informar que o(a) beneficiário(a)" +
                   "     não é um <span style='text-decoration: underline;'>funcionário público</span>, <span style='text-decoration: underline;'>estou ciente</span> que a inexatidão dessa" +
                   "     informação, poderá acarretar notificações à Fundação e a coordenação do" +
                   "     projeto, solicitando esclarecimentos sobre a divergência dos dados fornecidos." +
                   "     <br /><br />" +
                   " </div>"

        return this.configuracao.solBolsaMsgConfirmacao;
      }
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>

    <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

        <modal-liberar-cancelar :mostrar="modalLiberarCancelar"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoBolsa : ''"
                                :salvando="salvandoLiberacao"
                                :liberando="solBolsaMsgConfirmacao ? false : true"
                                :mensagem="solBolsaMsgConfirmacao"
                                :instrucao="configuracao.instrucoesLiberacaoSolBolsa"
                                @fechado="modalLiberarCancelarFechado"
                                @liberar="liberar"
                                @cancelar="cancelar">
        </modal-liberar-cancelar>

        <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoBolsa : ''"
                                    tipo="bolsa"
                                    @fechado="modalArquivosFechado">
        </modal-arquivos-solicitacao>

        <modal-protocolos :mostrar="modalProtocolos"
                          :numeroProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.numeroProtocolo : ''"
                          @fechado="modalProtocolosFechado">
        </modal-protocolos>

        <modal-mensagem :mostrar="modalMensagem"
                        :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                        :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoBolsa : ''"
                        tipo="SolBolsa"
                        @fechado="modalMensagensFechado">
        </modal-mensagem>

        <div class="row">
            <div class="col-lg-12">

                <div class="col-xs-12" v-if="this.configuracao.lgpdAvisoSolBolsa">
                    <h3 class="text-danger font-bold" v-if="this.configuracao.lgpdAvisoSolBolsa">{{configuracao.lgpdAvisoSolBolsa}}</h3>
                </div>

                <div class="ibox collapsed float-e-margins">
                    <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
                        <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

                        <div class="ibox-tools">
                            <span class="collapse-link">
                                <i class="fa fa-chevron-up"></i>
                            </span>
                        </div>
                    </div>
                    <div class="ibox-content">

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label class="control-label" for="projeto">Projeto</label>

                                    <select id="projeto"
                                            class="form-control"
                                            v-model="filtros.idProjeto">
                                        <option value="0">Todos</option>
                                        <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label class="control-label">Período</label>

                                    <date-picker v-model="filtros.periodo"
                                                 input-class="form-control"
                                                 range
                                                 :editable="false"
                                                 lang="pt-br"
                                                 :confirm="true"
                                                 range-separator="a"
                                                 format="DD/MM/YYYY"
                                                 :shortcuts="false">
                                    </date-picker>

                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-4">
                                <div class="form-group">
                                    <label class="control-label" for="codigo">Código da solicitação</label>

                                    <input type="text"
                                           class="form-control"
                                           id="codigo"
                                           v-model="filtros.codigo"
                                           v-numero>
                                </div>
                            </div>
                            <div class="col-xs-8">
                                <div class="form-group">
                                    <label class="control-label block">Mostrar solicitações</label>

                                    <radio v-model="filtros.mostrarSolicitacoes"
                                           selected-value="0"
                                           type="success"
                                           :inline="true"
                                           class="margin-right-10">
                                        Todas
                                    </radio>
                                    <radio v-model="filtros.mostrarSolicitacoes"
                                           selected-value="1"
                                           type="success"
                                           :inline="true"
                                           class="margin-right-10">
                                        Aguardando liberação
                                    </radio>
                                    <radio v-model="filtros.mostrarSolicitacoes"
                                           selected-value="2"
                                           type="success"
                                           :inline="true">
                                        Liberadas
                                    </radio>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group no-margins">
                                    <button type="button" class="btn btn-primary no-margins" @click="lista">
                                        <i class="fa fa-search"></i>
                                        Filtrar
                                    </button>
                                    <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                                        <i class="fa fa-search"></i>
                                        Limpar filtros
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ibox-footer">

                        <div class="table-responsive">
                            <table class="table table-bordered table-column-code table-column-action">
                                <thead>
                                    <tr>
                                        <th v-if="!configuracao.naoUtilizarMensageria">Mensagens</th>
                                        <th class="text-center">Número</th>
                                        <th>Tipo</th>
                                        <th>Nome</th>
                                        <th>Projeto</th>
                                        <th>Data</th>
                                        <th>Valor(R$)</th>
                                        <th v-if="configuracao.criarProtocoloSolicitacao">Protocolo</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(solicitacao, index) in solicitacoes">
                                        <td v-if="!configuracao.naoUtilizarMensageria">
                                            <div v-if="solicitacao.quantidadeNaoLida > 0">
                                                <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{solicitacao.quantidadeNaoLida}}
                                            </div>
                                        </td>
                                        <td class="text-center">{{ solicitacao.idSolicitacaoBolsa || '---' }}</td>
                                        <td>{{ tipoBolsa(solicitacao.tipoBolsa) }}</td>
                                        <td>{{ solicitacao.nome || '---' }}</td>
                                        <td>{{ solicitacao.nomeProjeto || '---' }}</td>
                                        <td>{{ solicitacao.dataSolicitacao | formatarData }}</td>
                                        <td>{{ solicitacao.valor | formatarNumero }}</td>
                                        <td v-if="configuracao.criarProtocoloSolicitacao">
                                            <a @click.prevent="mostrarModalProtocolos(solicitacao)" v-if="solicitacao.numeroProtocolo">{{ solicitacao.numeroProtocolo }} <i class="fa fa-external-link"></i></a>
                                            <span v-if="!solicitacao.numeroProtocolo">---</span>
                                        </td>
                                        <td>{{ status(solicitacao) }}</td>
                                        <td>
                                            <router-link class="btn btn-primary btn-xs"
                                                         active-class=""
                                                         v-tooltip="'Relatório'"
                                                         :to="{ name: 'solicitacao-bolsa.relatorio', params: { id: solicitacao.idSolicitacaoBolsa } }">
                                                <i class="fa fa-file-text-o"></i>
                                            </router-link>

                                            <router-link tag="button"
                                                         :disabled="liberadoOuCancelado(solicitacao)"
                                                         class="btn btn-secondary btn-xs"
                                                         active-class=""
                                                         v-tooltip="'Editar'"
                                                         :to="{ name: 'solicitacao-bolsa.editar', params: { id: solicitacao.idSolicitacaoBolsa } }">
                                                <i class="fa fa-pencil"></i>
                                            </router-link>

                                            <botao-reenviar-email :disabled="liberadoOuCancelado(solicitacao)"
                                                                  v-if="configuracao.usoEmailLiberarSolicitacao"
                                                                  :servico="reemviarEmail"
                                                                  :id="solicitacao.idSolicitacaoBolsa"
                                                                  @erro="erroReemviarEmail"
                                                                  @enviado="enviadoReemviarEmail">
                                            </botao-reenviar-email>

                                            <button v-if="!configuracao.usoEmailLiberarSolicitacao"
                                                    :disabled="liberadoOuCancelado(solicitacao)"
                                                    class="btn btn-warning btn-xs"
                                                    v-tooltip="'Liberar ou Cancelar solicitação'"
                                                    @click="mostrarModalLiberarCancelar(solicitacao)">
                                                <i class="fa fa-check"></i>
                                            </button>

                                            <button type="button"
                                                    class="btn btn-info btn-xs"
                                                    v-tooltip="'Listar arquivos da solicitação'"
                                                    @click="mostrarModalArquivos(solicitacao)"
                                                    v-if="configuracao.usarArquivosSolicitacaoBolsa">
                                                <i class="fa fa-archive"></i>
                                            </button>

                                            <button type="button"
                                                    class="btn btn-success btn-xs"
                                                    v-tooltip="'Ler\Enviar mensagem'"
                                                    @click="mostrarModalMensagem(solicitacao)"
                                                    v-if="!configuracao.naoUtilizarMensageria">
                                                <i class="fa fa-comment"></i>
                                            </button>

                                        </td>
                                    </tr>
                                    <tr v-show="carregando">
                                        <td colspan="8">
                                            <i class='fa fa-spinner fa-pulse'></i> Carregando...
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <paginacao :page-count="totalPaginas"
                                   :click-handler="lista"
                                   :per-page="registrosPorPagina"
                                   :register-count="totalRegistros"
                                   :show-counter="true">
                        </paginacao>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/SolicitacaoBolsaLista.vue